import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import { Dialog } from '@capacitor/dialog';

import { useDeleteAccountMutation } from '@/api/queries/auth';
import { useLogout } from '@/common/hooks/logout';
import { showToast } from '@/components/ui/Notification/SwipeableToastNotification';

// App Store requires in-app account deletion (guideline 5.1.1(v))
const DeleteAccount: FC = () => {
  const { t } = useTranslation();
  const [deleteAccount] = useDeleteAccountMutation();
  const logout = useLogout();

  if (!Capacitor.isNativePlatform()) return null;

  const handleDelete = async (): Promise<void> => {
    const { value } = await Dialog.confirm({
      title: t('Delete account?'),
      message: t(
        'Your progress, balances and purchases will be lost for good. This cannot be undone.',
      ),
      okButtonTitle: t('Delete'),
      cancelButtonTitle: t('Cancel'),
    });

    if (!value) return;

    try {
      await deleteAccount().unwrap();
      await logout();
    } catch {
      showToast(t('Something went wrong, please try again'));
    }
  };

  return (
    <button
      type="button"
      className="block mx-auto mt-6 px-4 py-2 text-sm font-medium text-[#FF5A5A]"
      onClick={() => void handleDelete()}
    >
      {t('Delete account')}
    </button>
  );
};

export { DeleteAccount };
